(function (factory) {
	if (typeof define === "function" && define.amd) {
	  define(["jquery"], function($) {
		factory($, window, document);
	  });
	} else if (typeof module === "object" && module.exports) {
	  module.exports = factory(require("jquery"), window, document);
	} else {
	  factory(jQuery, window, document);
	}
  }(function ($, window, document, undefined) {
	"use strict";
	const jQuery = $;

	/*
	Author:
	Petri Autio
	petri@crasman.fi
	2013

	Updated: 11.2.16
	Added support for customClass
*/

$.fn.huuCarousel = function() {
    return this.each(function() {
        var elem = $(this);
	    var position = 0;
	    var items = $(this).find('.slider > div').size();
	    createDots(items)
	    elem.find('.slider div').eq(0).addClass('center');
	    if(items > 1){
	        // Add slide buttons
	        elem.append('<div class="move left"></div><div class="move right"></div>')
	        elem.find('.move.left').click(moveLeft);
	        elem.find('.move.right').click(moveRight);
	    }
	    elem.find('.slider').css({
	        width: items*100+'%'
	    })
	    var width = 50/items;
	    elem.find('.slider > div').css({
	        width: width + '%'
	    });

	    elem.find('.slider > div:first-child').css({
	        marginLeft: width/2 + '%'
	    });

	    function moveRight(){
	        position++;
	        if(position == items)
	            position = 0;
	        moveToPosition(position);
	    }
	    function moveLeft(){
	        position--;
	        if(position < 0)
	            position = items-1;
	        moveToPosition(position);
	    }
	    function moveToPosition(position){
	    	var left = position*50;
	        elem.find('.slider > div').eq(position).addClass('center')
	        elem.find('.slider').css({
	            marginLeft: '-'+left+'%'
	        });
	        moveDot(position);
	    }
	    function createDots(amount){
	        elem.append('<div class="dots"></div>');
	        for(var i = 0; i < amount; i++){
	            elem.find('.dots').append('<div class="dot"></div>');
	        }
	        elem.find('.dots div').eq(0).addClass('active');
	        elem.find('.dots div').click(function(){
	            position = $(this).index();
	            moveToPosition(position);
	        });
	    }
	    function moveDot(position){
	        elem.find('.dots div').removeClass('active');
	        elem.find('.dots div').eq(position).addClass('active');
	    }
	});
};
$.fn.huuLightBox = function(options) {
	var settings = $.extend({}, options);

	if(settings.usehash == true){
		$(window).bind('hashchange', closeLightbox)
	}else{
		$('body').on('click', '#huuLightBoxClose', manuallyCloseLightbox);
		$('body').on('click', '#huuLightBox', manuallyCloseLightbox);
		$('body').on('click', '.close-huuLightBox-modal', manuallyCloseLightbox);
		$('body').on('click', '#huuLightBoxContent', function(e){
			e.stopPropagation();
		});
	}


	function closeLightbox(e){
		e.preventDefault();
		if(window.location.hash == '' || window.location.hash == '#'){
          	$('#huuLightBoxCloseContainer').remove();
			$('#huuLightBox').removeClass('huuAppear');
			//$('body').css({'overflowY' : 'auto'});
    		setTimeout(function(){
    			$('#huuLightBox').remove();
    		}, 500);

		}
	}
	function manuallyCloseLightbox(e){
		e.preventDefault();
      	$('#huuLightBoxCloseContainer').remove();
		$('#huuLightBox').removeClass('huuAppear');
		//$('body').css({'overflowY' : 'auto'});
		setTimeout(function(){
			$('#huuLightBox').remove();
		}, 500);
	}
    return this.each(function() {
    	/*
    		esimerkki:

		 	$('img').huuLightBox();
		 	Avaa kuvan lightboxiin uuteen img tagiin

		 	$('a').huuLightBox({type: 'iframe'})
			Avaa linkin lightboxin sisään iframeen

		 	$('a').huuLightBox()
			Lataa linkin sisällön ajaxilla lightboxin containeriin

    		$('a').huuLightBox({type : 'dom', source : '#popupLogin'})
            Näyttää palan domia lightboxissa

            $('a').huuLightBox({type: 'img', customClass : 'full'})
			Avaa linkin kuvan lightboxin sisään
		*/

        var elem = $(this);
	    var href, hrefEnding, src;
	    var imgs = 'jpg|jpeg|gif|png';
	    elem.click(open);

	    var hashChange = null;
	    function open(e){
	    	e.preventDefault();
	    	//$('body').css({'overflowY' : 'hidden'});
	    	href = elem.attr('href');
	    	if(href){
	    		hrefEnding = href.split('.').pop().toLowerCase();
	    	}
	    	src = elem.attr('src');
	    	if(settings.type == 'dom' && settings.source != ''){

	    		markUp($(settings.source).html());
	    	}else if(settings.type == 'iframe'){
	    		var data = '<iframe src="' + href + '"></iframe>';
		    	markUp(data);
		    	if(href.indexOf('youtube') > -1){
			    	$('#huuLightBoxContent').css({
			    		minHeight: '400px'
			    	})

			    }else{
			    	$('#huuLightBoxContent').css({
			    		height: '90%'
			    	})
			    }
			}else if(settings.type == 'img'){
				var data = '<img src="' + href + '" alt="">';
				markUp(data, 'img');
	    	}else if(typeof(src) != 'undefined' ||  imgs.indexOf(hrefEnding) > -1){
		    	if(imgs.indexOf(hrefEnding) > -1){
		    		src = href;
		    	}
		    	var data = '<img src="' + src + '">';
		    	markUp(data, 'img');
		    }else if(typeof(href) != 'undefined'){
		    	markUp('Hetkinen...');
		    	$.get(href, function(result){
		    		$('#huuLightBoxContent').html(result);
		    	}).error(function(){
		    		$('#huuLightBox').remove();
		    	});
		    }

		    //hashChange = window.addEventListener("hashchange", closeLightbox, false);



	    }

	    function markUp(data, contentCss){
	    	$('#huuLightBox').remove();
	    	var link = (settings.usehash == true) ? '#' : '';
	    	var conCss = (typeof contentCss !== "undefined") ? contentCss : '';
	    	var cusCss = (typeof settings.customClass !== "undefined") ? settings.customClass : '';
	    	var cssClass = 'class="'+conCss+' '+cusCss+'"';

	    	$('body').prepend('<div id="huuLightBox">\
				<div id="huuLightBoxCloseContainer"><a href="' + link + '" id="huuLightBoxClose"><i class="is-icon is-icon-arrow-left"></i>Takaisin</a></div>\
				<div id="huuLightBoxContainer">\
	    			<div id="huuLightBoxContent" ' + cssClass + '>\
	    				' + data + '\
	    			</div>\
	    		</div>\
	    	</div>');

	    	setTimeout(function(){
	    		$('#huuLightBox').toggleClass('huuAppear')
	    	}, 100);
	    	setTimeout(function(){
	    		$('#huuLightBoxCloseContainer').fadeIn('fast')
	    	}, 600);
	    	if(settings.usehash == true){
	    		window.location.hash = '#lighboxOpen'
	    	}


	    }

	});
};

}));
